import AaSequenceAnnotationsView, {
  AaSequenceAnnotationsViewOptions,
  AaSequenceAnnotationView,
} from 'molbio/aa-sequences/AaSequenceAnnotationsView';
import {ProteinAnnotationVersion} from 'molbio/aa-sequences/util/AaSequenceConstants';
import Type from 'molbio/maps/Type';
import AaSequenceAlignmentTabState from 'molbio/tabstates/AaSequenceAlignmentTabState';

interface AaSequenceAlignmentAnnotationsViewOptions extends AaSequenceAnnotationsViewOptions {
  annotations: Array<ProteinAnnotationVersion>;
}

export default class AaSequenceAlignmentAnnotationsView extends AaSequenceAnnotationsView {
  override tabstate!: AaSequenceAlignmentTabState;
  annotations!: Array<ProteinAnnotationVersion>;

  constructor(options: AaSequenceAlignmentAnnotationsViewOptions) {
    super(options);
    this.annotations = options.annotations;
    this.className = 'proteinAlignmentAnnotations';
  }

  override getPolymerLength(): number {
    return this.tabstate.getPolymerLength();
  }

  override contextMenuOptions(): Array<string> {
    return [];
  }

  override shouldSyncToStore(): boolean {
    return false;
  }

  override isAnnotationHovered(annotation: ProteinAnnotationVersion): boolean {
    return false;
  }

  override isAnnotationSelected(annotation: ProteinAnnotationVersion): boolean {
    return false;
  }

  override getAaSequenceId(): string | null {
    return null;
  }

  override getAnnotations(): Array<ProteinAnnotationVersion> {
    return this.annotations;
  }

  override getResiduesType(): Type {
    return this.tabstate.getType();
  }

  override clickAction(e: MouseEvent, d: AaSequenceAnnotationView): void {
    this.tabstate.get('selection').setEndpoints(d.start(), d.end());
  }

  override dblClickAction(e: MouseEvent, d: AaSequenceAnnotationView): void {}
}
